import {Navigate} from "react-router-dom";
import {useUserAttributes} from "../../../hooks/useUserAttributes.ts";
import {MarketingComponent} from "../components/MarketingComponent.tsx";

export const PublicHomePage = () => {

    const {sub} = useUserAttributes();

    if (sub && sub !== '') {
        return <Navigate to={'/dashboard'}/>;
    } else {
        return <MarketingComponent/>
    }

};
